import { FilterCode } from 'gql/autogen/FilterCode';
import { FilterState } from 'component/common/Filter/Filter.types';

export const mapSelectedFiltersToAnalyticsField = (allFilters: FilterState) => {
    const result: string[] = [];
    if (allFilters) {
        const { valueFilterMatrix, rangeFilterMatrix } = allFilters;
        valueFilterMatrix.forEach((filter) => {
            result.push(`${filter.code}=${filter.values.join('&')}`);
        });

        const priceFilter = rangeFilterMatrix.find((filter) => filter.code === FilterCode.Price);
        if (priceFilter) {
            const priceRange: string[] = [];
            const { ranges } = priceFilter;
            ranges.forEach((range) => {
                priceRange.push(`${range.lowerBound?.value}-${range.upperBound?.value}`);
            });

            result.push(`${priceFilter.code}=${priceRange.join('&')}`);
        }

        const ratingFilter = rangeFilterMatrix.find((filter) => filter.code === FilterCode.Rating);
        if (ratingFilter) {
            const ratingRange: string[] = [];
            const { ranges } = ratingFilter;
            ranges.forEach((range) => {
                ratingRange.push(`${range.lowerBound?.value}`);
            });

            result.push(`${ratingFilter.code}=${ratingRange.join('&')}`);
        }
    }

    return result.join(',');
};
